<script setup lang="ts">
import { computed } from 'vue';
import { icons, type IconName, type Shape } from './icons.js';
const props = defineProps<{ name: IconName }>();
const shapes = computed<readonly Shape[]>(() => icons[props.name]);
</script>

<template>
  <svg
    class="ui-icon"
    :data-icon="props.name"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <template v-for="(shape, index) in shapes" :key="index">
      <circle
        v-if="'c' in shape"
        :cx="shape.c[0]"
        :cy="shape.c[1]"
        :r="shape.c[2]"
        :class="{ filled: shape.fill }"
      />
      <path v-else :d="shape.d" :class="{ filled: shape.fill }" />
    </template>
  </svg>
</template>
